/** Format a decimal-string (backend sends decimals as strings) as BRL. */
export function formatBRL(value: string | number | null | undefined): string {
  if (value == null) return "—";
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

/** Format a decimal fraction string (0–1) as a percentage, e.g. "0.1500" -> "15%". */
export function formatPct(value: string | number | null | undefined): string {
  if (value == null) return "—";
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  return `${(n * 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;
}

/** Format up to 14 digits as a CNPJ mask (00.000.000/0000-00). */
export function formatCnpj(value: string | null | undefined): string {
  const d = (value || "").replace(/\D/g, "").slice(0, 14);
  if (d.length > 12) {
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
  }
  if (d.length > 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  if (d.length > 5) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length > 2) return `${d.slice(0, 2)}.${d.slice(2)}`;
  return d;
}

/** Format up to 11 digits as a CPF mask (000.000.000-00). */
export function formatCpf(value: string | null | undefined): string {
  const d = (value || "").replace(/\D/g, "").slice(0, 11);
  if (d.length > 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  if (d.length > 6) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  if (d.length > 3) return `${d.slice(0, 3)}.${d.slice(3)}`;
  return d;
}

/** Mask digits as CPF (≤11) or CNPJ (>11) by length. */
export function formatDocument(value: string): string {
  const d = value.replace(/\D/g, "");
  return d.length > 11 ? formatCnpj(d) : formatCpf(d);
}

/** Telefone BR mask: (11) 0000-0000 ou (11) 90000-0000. */
export function fmtTelefone(v: string): string {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

// Validador de comprimento (não valida dígitos verificadores).
export const isCpfLen = (v: string): boolean => (v || "").replace(/\D/g, "").length === 11;

/** Format an ISO date string as dd/mm/yyyy. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("pt-BR");
}
